"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["disabled"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DISABLED_COLOR = '#dadadd';
var GoogleCloudLogo = function GoogleCloudLogo(_ref) {
  var disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  function disabledFill(enabledColor) {
    var disabledColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DISABLED_COLOR;
    return disabled ? disabledColor : enabledColor;
  }
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 89",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M64.565 70.645L54.543 87.962H28.304A6.544 6.544 0 0122.64 84.7L1.425 47.911a6.44 6.44 0 010-6.458l8.075-14 9.98 17.223 15.033 25.969h30.052z",
    fill: disabledFill('#F8BB16')
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M97.64 47.907L76.424 84.694a6.544 6.544 0 01-5.665 3.263H54.556L64.578 70.64l15.033-25.97-15.033-25.969H84.54l13.113 22.747a6.474 6.474 0 01-.014 6.459z",
    fill: disabledFill('#EA4334')
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M84.518 18.708H34.491l-15.02 25.97-9.967-17.223 13.14-22.801A6.544 6.544 0 0128.31 1.39h42.443a6.544 6.544 0 015.664 3.263l8.102 14.054z",
    fill: disabledFill('#0074BC')
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M64.565 18.708l15.033 25.97-15.033 25.969H34.514L19.48 44.677l15.033-25.969h30.051z",
    fill: disabledFill('#E2E3E4', '#EEE')
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M49.538 31.69c7.216 0 13.058 5.808 13.058 12.984s-5.842 12.985-13.058 12.985c-7.217 0-13.059-5.809-13.059-12.985 0-7.176 5.842-12.985 13.059-12.985z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: 0.2,
    d: "M22.645 5.2a6.544 6.544 0 015.665-3.263h42.442A6.544 6.544 0 0176.417 5.2l7.789 13.513h.313L76.417 4.659a6.544 6.544 0 00-5.665-3.263H28.31a6.544 6.544 0 00-5.665 3.263l-13.14 22.8.164.271L22.645 5.2z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: 0.2,
    d: "M19.472 44.67L34.505 18.7h50.014l-.314-.541H34.492L19.46 44.129",
    fill: disabledFill('#2C3079')
  }));
};
var _default = GoogleCloudLogo;
exports.default = _default;